import axios from '../libs/api.request'

export const getArticleList = (params) => {
  return axios.request({
    url: 'main/article/getList',
    method: 'get',
    params
  })
}

export const saveArticle = (data) => {
  return axios.request({
    url: 'main/article/save',
    method: 'post',
    data
  })
}
/**
 * 删除文章
 * @returns {wx.RequestTask | never}
 */
export const deleteArticle = (data) => {
  return axios.request({
    url: 'main/article/delete',
    method: 'post',
    data
  })
}

/**
 * 删除评论
 * @returns {wx.RequestTask | never}
 */
export const deleteComment = (data) => {
  return axios.request({
    url: 'main/article/delComment',
    method: 'post',
    data
  })
}
/**
 * 审核文章
 * @returns {wx.RequestTask | never}
 */
export const examineArticle = (data) => {
  return axios.request({
    url: 'main/article/examineArticle',
    method: 'post',
    data
  })
}

/**
 * 审核评论
 * @returns {wx.RequestTask | never}
 */
export const examineComment = (data) => {
  return axios.request({
    url: 'main/article/examineComment',
    method: 'post',
    data
  })
}

export const getCategoryList = (params) => {
  return axios.request({
    url: 'main/article/getCategoryList',
    method: 'get',
    params
  })
}

export const saveCategory = (data) => {
  return axios.request({
    url: 'main/article/saveCategory',
    method: 'post',
    data
  })
}

export const deleteCategory = (data) => {
  return axios.request({
    url: 'main/article/deleteCategory',
    method: 'post',
    data
  })
}
/**
 * 获取评论列表
 * @returns {wx.RequestTask | never}
 */
export const getAdminCommentList = (params) => {
  return axios.request({
    url: 'main/article/getAdminCommentList',
    method: 'get',
    params
  })
}

/**
 * 获取公告
 * @returns {wx.RequestTask | never}
 */
export const getNoticeList = (params) => {
  return axios.request({
    url: 'main/article/getNoticeList',
    method: 'get',
    params
  })
}
/**
 * 删除公告
 * @returns {wx.RequestTask | never}
 */
export const delNotice = (data) => {
  return axios.request({
    url: 'main/article/delNotice',
    method: 'post',
    data
  })
}

/**
 * 更新公告
 * @returns {wx.RequestTask | never}
 */
export const saveNotice = (data) => {
  return axios.request({
    url: 'main/article/saveNotice',
    method: 'post',
    data
  })
}
